import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { CoreService } from '../../../../services/core.service';
import { SubmitGridComponent } from '../../components/submit-grid/submit-grid.component';
import { SectionGridComponent } from '../../components/section-grid/section-grid.component';
import { StepperGridComponent } from '../../components/stepper-grid/stepper-grid.component';
import { FooterGridComponent } from '../../components/footer-grid/footer-grid.component';

@Component({
  selector: 'app-create-video-template',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, SectionGridComponent, SubmitGridComponent, StepperGridComponent, FooterGridComponent],
  templateUrl: './create-video-template.component.html',
  styleUrl: './create-video-template.component.scss'
})
export class CreateVideoTemplateComponent implements OnInit {
  videoTemplateForm: FormGroup;
  companyId: string | null = null;
  contentSiteId: string | null = null;
  selectOptions: {
    feeds: any[]
  } = {
    feeds: []
  };

  @Output() onSubmitClbk = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private coreService: CoreService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.videoTemplateForm = this.fb.group({
      template_name: ['', Validators.required],
      template_id: ['', Validators.required],
      slides_number: ['', [Validators.required, Validators.min(1)]],
      rss_feed_id: ['', Validators.required]
    });
  }

  ngOnInit() {
    // Get company and site IDs from route parameters
    this.route.params.subscribe(params => {
      this.companyId = params['company'];
      this.contentSiteId = params['site'];
      console.log('Company ID from route:', this.companyId);
      console.log('Site ID from route:', this.contentSiteId);

      if (this.companyId) {
        // Load feeds for this company
        this.loadFeeds();
      }
    });

    // Check if editing existing video template
    // if (this.formData?.ID) {
    //   this.loadVideoTemplateData(this.formData.ID);
    // }
  }

  private loadFeeds(): void {
    // Load RSS feeds for the company
    this.coreService.getData(`/manageAccount/rss-feeds?companyID=${this.companyId}`).subscribe({
      next: (data) => {
        this.selectOptions.feeds = data || [];
        console.log('Loaded feeds:', this.selectOptions.feeds);
        
        // Auto-select feed if contentSiteId is provided and matches
        if (this.contentSiteId && this.selectOptions.feeds.length > 0) {
          // Find feed associated with this site
          const associatedFeed = this.selectOptions.feeds.find(feed => 
            feed.ms_contentsite_id == this.contentSiteId
          );
          
          if (associatedFeed) {
            this.videoTemplateForm.patchValue({
              rss_feed_id: associatedFeed.id
            });
          }
        }
      },
      error: (error) => {
        console.error('Error loading feeds:', error);
      }
    });
  }

  private loadVideoTemplateData(templateId: string): void {
    this.coreService.getData(`manageAccount/video-template/${templateId}`).subscribe({
      next: (data) => {
        this.videoTemplateForm.patchValue(data);
      },
      error: (error) => {
        console.error('Error loading video template data:', error);
      }
    });
  }

  // Helper method to get form controls
  getControl(controlName: string) {
    return this.videoTemplateForm.get(controlName);
  }

  onSubmit(): void {
    if (this.videoTemplateForm.valid) {
      // Get form values
      const formData = this.videoTemplateForm.value;

      // Add companyID and contentSiteID from route params
      const dataToSubmit = {
        ...formData,
        companyID: this.companyId,
        ms_contentsite_id: this.contentSiteId
      };

      // Determine if this is create or update
      // const endpoint = this.formData?.ID 
      //   ? `manageAccount/video-template/update/${this.formData.ID}`
      //   : 'manageAccount/video-template/store';

      this.coreService.postData('manageAccount/video-template/store', dataToSubmit).subscribe({
        next: (data) => {
          console.log('Video template operation successful:', data);

          const companyId = data.companyID || data.data?.companyID;

          if (companyId) {
            this.router.navigate(['/manage-account/create-pricing-plan', companyId]);
          } else {
            console.error('No company ID found in response:', data);
          }
        
          // Optional: Reset form
          // this.resetForm();
        },
        error: (error) => {
          console.error('Error creating/updating video template:', error);

          // Handle specific errors
          if (error.status === 400) {
            alert('Invalid video template data. Please check your inputs.');
          } else if (error.status === 409) {
            alert('Video template already exists.');
          }
        }
      });
    } else {
      this.markFormGroupTouched(this.videoTemplateForm);
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  resetForm(): void {
    this.videoTemplateForm.reset({
      template_name: '',
      template_id: '',
      slides_number: '',
      rss_feed_id: ''
    });

    this.videoTemplateForm.markAsPristine();
    this.videoTemplateForm.markAsUntouched();
  }
}
